import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  country: [],
  editCountry: [],
  addCountry: [],
  deleteCountry: [],
};

const CountrySlice = createSlice({
  name: "expertise",
  initialState,
  reducers: {
    CountryRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.country = [];
    },
    CountrySuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.country = action.payload;
    },
    CountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.country = [];
    },

    editCountryRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.editCountry = [];
    },
    editCountrySuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.editCountry = action.payload;
    },
    editCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.editCountry = [];
    },

    addCountryRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.addCountry = [];
    },
    addCountrySuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.addCountry = action.payload;
    },
    addCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.addCountry = [];
    },

    deleteCountryRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.deleteCountry = [];
    },
    deleteCountrySuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.deleteCountry = action.payload;
    },
    deleteCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.deleteCountry = [];
    },
  },
});

export const CountryAction = CountrySlice.actions;
export default CountrySlice;
